import { Capacitor } from '@capacitor/core';
import _ from 'underscore'
import PromoCodeViewTemplate from '../templates/promo-code.tpl'
import FormView from './form'
import messages from '../messages'
import Alert from '../helpers/alert'
import config from '../config'
import Backbone from 'backbone'
import { getPriceBySlug, purchaseAppBySlug } from '../iap';

const PromoCodeView = FormView.extend({
    events: {
        'click .close' : 'close',
        'click .submit' : 'addPromo',
        'click .purchase' : 'purchase',
    },
    handheld: false,
    appExists: false,
    ios: false,
    price: null,
    initialize() {
        this.template = _.template(PromoCodeViewTemplate)
        this.handheld = config.get('handheld')
        this.ios = Capacitor.getPlatform() === 'ios'
        this.price = getPriceBySlug(config.get('slug'))
    },
    render() {
        this.appExists = config.get('id') !== null
        return FormView.prototype.render.apply(this, arguments)
    },
    addPromo() {
        const code = this.$el.find('#promo').val()

        new Promise((resolve, reject) => {
            if (code.trim() === '') {
                reject(messages.MSG_PROMO_BLANK)
            }

            resolve()
        })
            .then(() => this.model.get('purchased').addPromo(code))
            .then(() => this.close())
            .catch(Alert)
    },
    purchase() {
        const btn = this.$('.button.purchase')

        // update button so they know its processing
        btn.addClass('disabled')
            .text('Processing…')
            .off('click')

        // start purchase
        purchaseAppBySlug(config.get('slug'))
            .then(() => this.close())
            .catch(error => {
                // restore button
                btn.removeClass('disabled')
                    .text(`Purchase for ${this.price}`)
                    .on('click', this.purchase.bind(this))

                Alert(error)
            })
    },
    close() {
        const slug = config.get('slug')

        if (Backbone.history.fragment === 'school') {
            Backbone.history.navigate('', {trigger: true, replace: true})
            Backbone.history.navigate('school', {trigger: true, replace: true})
        } else if (Backbone.history.fragment.startsWith(`app/${slug}`)) {
            Backbone.history.navigate(`app/${slug}`, { trigger: true })
        } else {
            Backbone.history.navigate('', {trigger: true})
        }
    }
})

export default PromoCodeView